import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Api } from "../../services/api";

function urlSafeBase64Decode(value) {
  return atob(
    value.split(".").join("=").split("-").join("/").split("_").join("+")
  );
}
/**
 * Generated class for the CreateWeixinLoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment: "cwxl/:id/:token/:jumpbackUrl",
})
@Component({
  selector: "page-create-weixin-login",
  templateUrl: "create-weixin-login.html",
})
export class CreateWeixinLoginPage {
  state = "init";

  constructor(
    public navCtrl: NavController,
    private api: Api,
    public navParams: NavParams
  ) {
    document.title = "微信绑定";
  }

  confirm() {
    this.api
      .createWxLogin(+this.navParams.data.id, this.navParams.data.token)
      .then((data) => {
        if (data.ok) {
          this.state = "done";

          const jumpbackUrl = urlSafeBase64Decode(
            this.navParams.data.jumpbackUrl
          );
          if (jumpbackUrl != "nop") {
            setTimeout(() => {
              window.location.href = jumpbackUrl;
            }, 1500);
          }
        }
      })
      .catch((err) => {
        if (err.errMsg == "already bound") {
          this.state = "alreadyBound";
        } else {
          this.state = "errored";
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/create-weixin-login/create-weixin-login.ts